import { Paper, Box, Typography, Chip } from "@mui/material";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import React from "react";
import { useTranslation } from "react-i18next";
import { formatDate, formatTimestampToDate } from "utils/formats";
import { NotificationResponse } from "api/generatedApi";

interface Props {
  notification: NotificationResponse;
  onClick: () => void;
}

export const NotificationItem: React.FC<Props> = ({ notification, onClick }) => {
  const { t } = useTranslation();

  return (
    <Paper
      elevation={3}
      tabIndex={0}
      role="button"
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        p: 1.5,
        minWidth: 300,
        cursor: "pointer",
        bgcolor: (notification.unreadNotificationCount ?? 0) > 0 ? "primary.light" : "background.paper",
        borderLeft: (notification.unreadNotificationCount ?? 0) > 0 ? "6px solid" : "6px solid transparent",
        borderLeftColor: (notification.unreadNotificationCount ?? 0) > 0 ? "primary.main" : "transparent",
      }}
    >
      {(notification.unreadNotificationCount ?? 0) > 0 ? <MarkEmailUnreadIcon color="primary" sx={{ fontSize: 32 }} /> : <MarkEmailReadIcon color="action" sx={{ fontSize: 32 }} />}
      <Box sx={{ flex: 1 }}>
        <Typography variant="subtitle1" fontWeight="bold">
          {t(`account.notifications.headlines.${notification.category}`)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {notification.projectName}
        </Typography>
        <Typography variant="body2">
          {t("account.notifications.receivedAt")} {formatDate(formatTimestampToDate(notification.latestNotificationReceivedAt))}
        </Typography>
      </Box>
      <Chip color={(notification.unreadNotificationCount ?? 0) > 0 ? "primary" : "default"} label={`${t("account.notifications.unreadCount")}: ${notification.unreadNotificationCount ?? 0}/${notification.notificationCount}`} sx={{ ml: 2 }} />
    </Paper>
  );
};
